
export const imageCodes = {
  gr: {
    code: "${merchantId}_tmpl_img_2",
    image:
      "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fgr1.png?alt=media&token=e92ea83f-3921-425a-b3d5-43427689388f",
  },
  gr1: {
    code: "${merchantId}_tmpl_img_1",
    image:
      "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fgr.png?alt=media&token=075fedde-bca5-4336-b25b-2c87836cc51f",
  },
  gr2: {
    code: "${merchantId}_tmpl_img_3",
    image:
      "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fgr2.png?alt=media&token=9226c5a3-6bc5-445f-b798-5c7d89a17a8f",
  },
  cat: {
    code: "${merchantId}_tmpl_img_4",
    image:
      "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fcat.png?alt=media&token=c2fa50e4-72d0-4893-b033-b593b6c1bb8e",
  },
  cat1: {
    code: "${merchantId}_tmpl_img_5",
    image:
      "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fcat1.png?alt=media&token=3c61ba45-1ab3-4c61-b4ae-684388b9143f",
  },
  cat2: {
    code: "${merchantId}_tmpl_img_6",
    image:
      "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fcat2.png?alt=media&token=b9747218-f0de-43fc-96f9-f4ebf1525285",
  },
  cat3: {
    code: "${merchantId}_tmpl_img_7",
    image:
      "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fcat3.png?alt=media&token=719b1da2-924a-48c4-9eaf-fa69e94e2484",
  },
  cat4: {
    code: "${merchantId}_tmpl_img_8",
    image:
      "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fcat4.png?alt=media&token=544251ed-bfb7-4730-87ef-d13d5372c723",
  },
  cat5: {
    code: "${merchantId}_tmpl_img_9",
    image:
      "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fcat5.png?alt=media&token=5ec34324-432a-42fc-8639-cef23dc5775c",
  },
  hero: {
    code: "${merchantId}_tmpl_img_10",
    image:
      "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2FIMG_3955.jpg?alt=media&token=d05ee36e-7e9e-46a8-b3db-de16958a199b",
  },
  top1: {
    code: "${merchantId}_tmpl_img_11",
    image:
      "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fp1.png?alt=media&token=d89cd521-f0a2-4c69-b011-33732c860167",
  },

  top2: {
    code: "${merchantId}_tmpl_img_12",
    image:
      "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fp2.png?alt=media&token=5860b245-dbd5-4fbc-90af-1edd1cf5e193",
  },

  top3: {
    code: "${merchantId}_tmpl_img_13",
    image:
      "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fp3.png?alt=media&token=2781ef06-3522-4932-9c45-205678d6aa35",
  },

  top4: {
    code: "${merchantId}_tmpl_img_14",
    image:
      "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fp4.png?alt=media&token=aea06ed7-695b-46ef-ab4a-b91ec4b682ee",
  },
  cat6: {
    code: "${merchantId}_tmpl_img_15",
    image:
      "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fcat6.png?alt=media&token=105eaec9-a098-4f62-923f-71183980feb4",
  },
  cat7: {
    code: "${merchantId}_tmpl_img_17",
    image:
      "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2FGroup%2017.png?alt=media&token=adbf1c2f-bc54-48da-9d8e-e99e0c346b75",
  },
  cat8: {
    code: "${merchantId}_tmpl_img_18",
    image:
      "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2FIMG-affbe587958859510bb828188b9aa15f-V.jpg?alt=media&token=735d861d-ef60-4f99-8a29-255c236d6ec1",
  },
  cat9: {
    code: "${merchantId}_tmpl_img_19",
    image:
      "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2FIMG-b6d76c8dae6bcfa96d54355716ce92bc-V.jpg?alt=media&token=5ee58a87-4911-4491-9cfd-8cf3f4160562",
  },
  cat10: {
    code: "${merchantId}_tmpl_img_20",
    image:
      "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2FGroup%2015.png?alt=media&token=96d93245-cdb2-47da-92e2-2f3f0cc459a9",
  },
  cat11: {
    code: "${merchantId}_tmpl_img_21",
    image:
      "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2FIMG-dd9a262ee5ba00c4149eaeb7ec21e53c-V.jpg?alt=media&token=dbc5d6e6-028b-41ec-8ecd-b65bc89544ad",
  },
  cat12: {
    code: "${merchantId}_tmpl_img_22",
    image:
      "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2FGroup%2016.png?alt=media&token=993335c7-828f-4424-95d3-633152623ed8",
  },
  cat13: {
    code: "${merchantId}_tmpl_img_23",
    image:
      "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2FIMG-f5cb4a581b3934bf003fa5eb549b9a09-V.jpg?alt=media&token=360720ee-85e9-44f8-b00d-15cea65681de",
  },
  cat14: {
    code: "${merchantId}_tmpl_img_24",
    image:
      "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fdell.png?alt=media&token=fad769ec-e739-4205-ad1b-b18ec6d79ad1",
  },
};

export const videoCodes = {};

export const textCodes = {
  text: {
    code: "${merchantId}_tmpl_text_2",
    text: "ENCORE has been established since 2020 by 2 friends who are interested in street and grunge fashion. The type and style of clothing we wanted to wear was not available in our country at the time, so we started to develop and sell it our own.",
  },

  shopNow: {
    code: "${merchantId}_tmpl_text_1",
    text: "S H O P N O W",
  },
};

export const titleCodes = {
  title: {
    code: "${merchantId}_tmpl_title_1",
    title: "Top Product",
  },
  title1: {
    code: "${merchantId}_tmpl_title_2",
    title: "Brand We Stocks",
  },
};
